import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { content } from "../i18n/content";

export const Testimonials = () => (
  <section id="voices" className="relative py-28 sm:py-40" data-testid="testimonials-section">
    <div className="max-w-[1500px] mx-auto px-6 sm:px-10">
      <div className="max-w-3xl mb-16 sm:mb-24">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-[11px] uppercase tracking-[0.35em] text-[#c86f53] mb-8"
          data-testid="testimonials-chapter-label"
        >
          {content.testimonials.chapter}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-4xl sm:text-6xl leading-[1.02] tracking-tight text-[#2a2626] font-medium"
          data-testid="testimonials-heading"
        >
          {content.testimonials.headingDe}
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.25 }}
          className="mt-3 font-display italic text-2xl sm:text-3xl text-[#6b705c] font-light"
          data-testid="testimonials-heading-en"
        >
          {content.testimonials.headingEn}
        </motion.p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
        {content.testimonials.items.map((item, i) => (
          <motion.blockquote
            key={i}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
            className={`bg-[#f2ebe1] border border-[#2a2626]/10 p-8 sm:p-10 flex flex-col ${i === 1 ? "md:mt-12" : ""}`}
            data-testid={`testimonial-${i}`}
          >
            <Quote size={22} className="text-[#c86f53] mb-6" strokeWidth={1.5} />
            <p className="text-sm sm:text-[15px] leading-relaxed text-[#2a2626]/85 font-light flex-1">
              {item.quoteDe}
            </p>
            <p className="mt-3 font-display italic text-base sm:text-lg leading-relaxed text-[#6b705c] font-light flex-1">
              {item.quoteEn}
            </p>
            <footer className="mt-8 pt-6 border-t border-[#2a2626]/10">
              <p className="text-[10px] uppercase tracking-[0.24em] text-[#5c5656]">{item.authorDe}</p>
              <p className="text-[9px] uppercase tracking-[0.24em] text-[#5c5656]/60">{item.authorEn}</p>
            </footer>
          </motion.blockquote>
        ))}
      </div>
    </div>
  </section>
);
